import { Reveal, MaskText, Eyebrow } from "@/components/motion";
import { CtaButton } from "@/components/CtaButton";

const PILLARS = ["Prodotti professionali e domiciliari formulati da noi", "Protocolli proprietari viso e corpo", "Formazione continua con le nostre Master"];

export const Method = () => (
  <section className="section border-t border-line" data-testid="method-section">
    <div className="wrap">
      <div className="grid gap-14 lg:grid-cols-2">
        <div>
          <Eyebrow>Il Metodo Skin Lovers · Natural Anti-Age</Eyebrow>
          <MaskText className="h2 mt-6" lines={["Non solo prodotti.", <em className="gold-text">Un metodo.</em>]} />
          <Reveal><p className="lead mt-8">Dal 2022 Skin Lovers sviluppa prodotti professionali e protocolli proprietari di Natural Anti-Age ed estetica rigenerativa, nati nella cabina di Valentina a Magione. Tutto lavora insieme, per dare alla cliente risultati concreti e a te clienti fedeli.</p></Reveal>
        </div>
        <div className="flex flex-col justify-center">
          {PILLARS.map((p, i) => (
            <Reveal key={p} delay={i * 0.1}>
              <div className="group flex items-baseline gap-6 border-b border-line py-7">
                <em className="w-12 shrink-0 font-serif text-4xl text-gold transition-colors duration-500 group-hover:text-gold-light">{["I", "II", "III"][i]}</em>
                <span className="text-lg text-cream md:text-xl">{p}</span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
      <Reveal>
        <p className="mt-20 max-w-4xl font-serif text-3xl italic leading-tight text-cream md:text-[2.6rem]">
          Fino a oggi ogni centro ha imparato un pezzo del metodo. <span className="gold-text">Ora abbiamo deciso di aprire tutte le porte.</span>
        </p>
      </Reveal>
    </div>
  </section>
);

const NIGHTS = [
  { day: "25", label: "Mercoledì 25 novembre", t: "Il metodo e il viso", items: ["Cos'è il Natural Anti-Age e l'estetica rigenerativa non invasiva", "Come nasce il Metodo Skin Lovers", "I protocolli viso e i loro risultati"] },
  { day: "26", label: "Giovedì 26 novembre", t: "Il corpo e il tuo centro", items: ["I protocolli corpo e i loro risultati", "Come il metodo diventa fatturato", "Come diventare Centro Official Partner"] },
];

export const Evenings = () => (
  <section id="serate" className="section border-t border-line bg-ink2" data-testid="evenings-section">
    <div className="wrap">
      <Eyebrow>Le 2 serate</Eyebrow>
      <MaskText className="h2 mt-6" lines={["Cosa vedrai,", "serata per serata"]} />
      <div className="mt-14 grid gap-5 md:grid-cols-2">
        {NIGHTS.map((n, i) => (
          <Reveal key={n.day} delay={i * 0.12} className="h-full">
            <article className="card-lux relative h-full overflow-hidden p-8 sm:p-10" data-testid={`evening-card-${n.day}`}>
              <span className="pointer-events-none absolute -right-4 -top-10 font-serif text-[11rem] font-semibold leading-none text-gold/[0.08]">{n.day}</span>
              <div className="text-[12px] font-semibold uppercase tracking-[0.2em] text-gold">{n.label}</div>
              <h3 className="mt-4 text-4xl text-cream">{n.t}</h3>
              <ul className="mt-8 space-y-4">
                {n.items.map((it) => (
                  <li key={it} className="flex gap-4 text-[15px] leading-relaxed text-sand">
                    <span className="mt-2 h-1.5 w-1.5 shrink-0 rotate-45 bg-gold" />{it}
                  </li>
                ))}
              </ul>
            </article>
          </Reveal>
        ))}
      </div>
      <Reveal>
        <div className="mt-5 flex gap-5 rounded-2xl border border-gold/30 bg-gold/[0.06] p-7 sm:p-8" data-testid="pact-box">
          <span className="font-serif text-2xl text-gold">◆</span>
          <p className="text-[15px] leading-relaxed text-cream">
            <b className="font-semibold text-gold-light">Un patto chiaro.</b> Ti mostriamo i risultati e ti spieghiamo cosa fa ogni protocollo.{" "}
            <span className="text-sand">I passaggi tecnici restano riservati alla formazione privata dei nostri centri.</span>
          </p>
        </div>
      </Reveal>
      <Reveal className="mt-12"><CtaButton testid="evenings-cta-btn">Voglio esserci</CtaButton></Reveal>
    </div>
  </section>
);
